import initialState from './ScreenInitialState';
import reducers from './ScreenReducer';

export default {
  initialState,
  reducers,
};
